<fc-search-input
  [label]="'FC_DEADLINE_VIOLATION_REASON.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayText]="displayText"
  [displayWith]="displayWith"
  [showSearchIcon]="false"
  [requiredMark]="false"
  [preloadOptions]="true"
  [searchOnFocus]="false"
></fc-search-input>
